import React, { useEffect, useState } from 'react';
import { FaArrowRight, FaLinkedin } from 'react-icons/fa';
import service_bg from "../assets/service-slider-bg.jpg";
import { Link } from 'react-router-dom';
import axios from 'axios';

const TeamMember = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await axios.get("https://apis.appnexts.com/api/team");
        if (Array.isArray(response.data)) {
          setTeamMembers(response.data);
        } else {
          setTeamMembers([]);
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
        setError("Could not load team members.");
      } finally {
        setLoading(false);
      }
    };

    fetchTeamMembers();
  }, []);

  if (loading) {
    return (
      <div className="w-full py-10 flex justify-center items-center">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
          <span className="text-white">Loading team members...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full py-10 text-center text-red-300">
        {error}
      </div>
    );
  }

  return (
    <div
      className="bg-cover bg-center text-white py-12"
      style={{ backgroundImage: `url(${service_bg})` }}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row justify-between items-center mb-8">
          <div className="text-center lg:text-left mb-6 lg:mb-0">
            <h3 className="text-[#504e9a] font-semibold mb-2 text-xl sm:text-2xl">
              Team Members
            </h3>
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
              Our Dedicated Team Members
            </h1>
          </div>

          <Link
            to="/our-team-members"
            className="relative hidden lg:flex bg-[#504e9a] text-white px-6 py-3 font-semibold rounded-full border-2 border-[#504e9a] overflow-hidden transition-transform duration-300 will-change-transform z-0 items-center justify-center group hover:text-[#504e9a] w-full sm:w-auto"
          >
            All Members
            <FaArrowRight className="ml-2 h-4 w-4 transition-transform -rotate-45 duration-300 transform group-hover:rotate-0" />
            <span className="absolute inset-0 bg-white rounded-full transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0 will-change-transform z-[-1]"></span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {teamMembers.map((member) => (
            <a
              key={member._id || member.id}
              href={member.linkedin || "https://www.linkedin.com"}
              target="_blank"
              rel="noopener noreferrer"
              className="relative flex flex-col group"
            >
              <div className="relative overflow-hidden rounded-t-lg">
                <img
                  src={member.image || member.member_img}
                  alt={member.name}
                  className="object-cover object-top w-full h-full transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <FaLinkedin className="text-white text-4xl" />
                </div>
              </div>
              <div className="bg-[#1e1b4b] text-white p-6 rounded-b-lg transition-colors duration-300 group-hover:bg-blue-600">
                <h3 className="text-xl font-bold mb-1">{member.name}</h3>
                <p className="text-gray-300">{member.designation}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamMember;
